// ./plugins/hojar.ts
import VueHotjar from "vue-hotjar-next";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueHotjar, {
    id: 3846204,
    isProduction: true,
    snippetVersion: 6,
  });
});
